// extracted by mini-css-extract-plugin
export default {"LoaderModal":"LoaderModal_LoaderModal__IYJGr","loader":"LoaderModal_loader__yaOYe","LoaderModalBackDrop":"LoaderModal_LoaderModalBackDrop__XnmA9"};